import React, { Component } from 'react'
import LoadingWindow from '../../../components/LoadingWindow';
import "../../../css/inventory-style.css"
import "../../../css/general-style.css"
import '../../../css/table-responsive.css'
import { getInformationWithData } from '../../../services/CABE';
import ExcelDocument from '../../../components/ExcelDocument';
import { getDataSet } from '../../../functions/generateDataSetExcel';

// Menu
import { Menu } from "../../../components/Menu/Menu";

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(to bottom right, #EFF6FF, #E0E7FF)',
    padding: '32px'
  },
  card: {
    maxWidth: '800px',
    margin: '0 auto',
    background: 'white',
    borderRadius: '8px',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    padding: '32px'
  },
  header: {
    marginBottom: '32px'
  },
  title: {
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#1F2937',
    marginBottom: '8px'
  },
  subtitle: {
    color: '#6B7280'
  },
  button: {
    width: '50%',
    padding: '12px 24px',
    borderRadius: '8px',
    fontWeight: '600',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    marginBottom: '24px',
    transition: 'all 0.2s'
  },
  buttonActive: {
    background: '#4F46E5',
  },
  buttonDisabled: {
    background: '#9CA3AF',
    cursor: 'not-allowed'
  },
  progressBox: {
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '24px',
    fontWeight: '500'
  },
  // successBox: {
  //   background: '#F0FDF4',
  //   color: '#166534'
  // },
  // errorBox: {
  //   background: '#FEF2F2',
  //   color: '#991B1B'
  // },
  infoBox: {
    background: '#EFF6FF',
    color: '#1E40AF'
  },
  logsContainer: {
    background: '#F9FAFB',
    borderRadius: '8px',
    padding: '16px',
    maxHeight: '384px',
    overflowY: 'auto'
  },
  logsTitle: {
    fontWeight: '600',
    color: '#374151',
    marginBottom: '12px'
  },
  logsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  logItem: {
    fontSize: '14px',
    padding: '8px',
    borderRadius: '4px',
    display: 'flex',
    gap: '8px'
  },
  logError: {
    background: '#FEE2E2',
    color: '#991B1B'
  },
  logWarning: {
    background: '#FEF3C7',
    color: '#92400E'
  },
  logSuccess: {
    background: '#D1FAE5',
    color: '#065F46'
  },
  logInfo: {
    background: '#E5E7EB',
    color: '#1F2937'
  },
  logTime: {
    fontSize: '12px',
    opacity: 0.7,
    fontFamily: 'monospace'
  },
  instructions: {
    marginTop: '32px',
    padding: '16px',
    background: '#EFF6FF',
    borderRadius: '8px',
    border: '1px solid #BFDBFE'
  },
  instructionsTitle: {
    fontWeight: '600',
    color: '#1E3A8A',
    marginBottom: '8px'
  },
  instructionsList: {
    fontSize: '14px',
    color: '#1E40AF',
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  spinner: {
  display: 'inline-block',
  animation: 'spin 1s linear infinite'
  },
  progressContainer: {
    background: '#F9FAFB',
    padding: '24px',
    borderRadius: '8px',
    marginBottom: '24px'
  },
  progressText: {
    fontSize: '14px',
    color: '#4B5563',
    marginBottom: '12px',
    fontWeight: '500'
  },
  progressBarBg: {
    width: '100%',
    height: '8px',
    background: '#E5E7EB',
    borderRadius: '4px',
    overflow: 'hidden',
    marginBottom: '8px'
  },
  progressBarFill: {
    height: '100%',
    background: 'linear-gradient(to right, #4F46E5, #7C3AED)',
    borderRadius: '4px',
    transition: 'width 0.3s ease'
  },
  progressSteps: {
    fontSize: '12px',
    color: '#6B7280',
    textAlign: 'right'
  },
  successBox: {
    background: '#F0FDF4',
    border: '1px solid #86EFAC',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'start',
    gap: '12px'
  },
  errorBox: {
    background: '#FEF2F2',
    border: '1px solid #FCA5A5',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'start',
    gap: '12px'
  },
  icon: {
    fontSize: '24px',
    fontWeight: 'bold'
  },
  successTitle: {
    color: '#166534',
    fontWeight: '600',
    fontSize: '16px',
    marginBottom: '4px'
  },
  successText: {
    color: '#15803D',
    fontSize: '14px'
  },
  errorTitle: {
    color: '#991B1B',
    fontWeight: '600',
    fontSize: '16px',
    marginBottom: '4px'
  },
  errorText: {
    color: '#DC2626',
    fontSize: '14px'
  },
};
export default class CurrentShippedItemsReport extends Component {

  // constructor(props) {
  //     super(props)
  // }

  state = {
    loading: false,
    progress: '',
    status: null, // 'success' | 'error' | null
    logs: [],
    data: [],
    errorMessage: 'Starting export process...',
    currentStep: 0,
    totalSteps: 0
  }

  // Add log message to state
  addLog = (message, type = 'info') => {
    const newLog = {
      message,
      type,
      timestamp: new Date().toLocaleTimeString()
    };
    
    // Using setState to add to logs array
    this.setState(prevState => ({
      logs: [...prevState.logs, newLog]
    }));
  };

// Make first request to get sales orders
  getSalesOrdersRequest = async () => {
    try {
      this.addLog('Making first request...');
      
      const payload = {
          SalespersonNo: "0000",
          idCompany: 3,
          idcompany: 3
      };

      // Using axios.post
      const response = await getInformationWithData('/sales/get/header', payload);

      // With axios, response.data already contains the parsed JSON
      const result = response.data;
      
      // Check status
      if (response.status.code !== 1) {
        this.addLog(`Warning: Status is ${result.status}`, 'warning');
      }

      // Extract data from nested structure
      const dataObj = result || {};
      const data = typeof dataObj === 'object' && !Array.isArray(dataObj)
        ? dataObj.Tabla2 || []
        : Array.isArray(dataObj) ? dataObj : [];

      // Extract sales order numbers
      const salesOrders = data
      .map(item => item.SalesOrderNo)
      .filter(Boolean); // Remove null/undefined values

      this.addLog(`Found ${salesOrders.length} sales orders`, 'success');
      return salesOrders;

    } catch (error) {
      // Axios provides better error details in error.response
      const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message;
      this.addLog(`Error in first request: ${errorMsg}`, 'error');
      throw error;
    }
  };

  // Make second request for specific sales order
  getSalesOrderItemsRequest = async (salesOrderNo) => {
    try {
      const detailPayload = {
        OrderNo: salesOrderNo,
        idcompany: 3,
        idCompany: 3
      };

      // Axios POST request
      const response = await await getInformationWithData('/sales/get/detail', detailPayload);

      const result = response.data;

      // Extract data from nested structure
      const dataObj = result || {};
      const data = typeof dataObj === 'object' && !Array.isArray(dataObj)
        ? dataObj.Tabla2 || []
        : Array.isArray(dataObj) ? dataObj : [];

      // Transform to required format
      const items = data.map(item => ({
        SalesOrder: salesOrderNo,
        itemCode: item.ItemCode || '',
        description: item.ItemCodeDesc || '',
        qty_ordered: item.QuantityOrdered || 0,
        qty_shipped: item.QuantityShipped || 0,
        invoiceNo: '' // Will be populated later
      }));

      return items;

    } catch (error) {
      const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message;
      this.addLog(`Error for order ${salesOrderNo}: ${errorMsg}`, 'error');
      return [];
    }
  };

  // Make third request to get invoices
  getInvoicedSalesOrdersRequest = async () => {
    try {
      this.addLog('Fetching invoice data...');

      const invoicePayload = {
        CustomerNo: "*",
        SalespersonNo: "0000",
        idCompany: 3,
        idcompany: 3
      };

      const response = await getInformationWithData('/invoice/header', invoicePayload);

      const result = response.data;

      // Extract data
      const dataObj = result || {};
      const data = typeof dataObj === 'object' && !Array.isArray(dataObj)
        ? dataObj.Tabla2 || []
        : Array.isArray(dataObj) ? dataObj : [];

      // Create invoice map (dictionary/object)
      const invoiceMap = {};
      data.forEach(item => {
        const salesOrder = item.salesOrderNo || item.SalesOrderNo;
        const invoiceNo = item.invoiceNo || item.InvoiceNo;
        if (salesOrder) {
          invoiceMap[salesOrder] = invoiceNo || '';
        }
      });

      this.addLog(`Created invoice mapping for ${Object.keys(invoiceMap).length} orders`, 'success');
      return invoiceMap;

    } catch (error) {
      const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message;
      this.addLog(`Error fetching invoices: ${errorMsg}`, 'error');
      return {};
    }
  };

  // Add invoice numbers to items
  addInvoiceNumbers = (allItems, invoiceMap) => {
    return allItems.map(item => ({
      ...item,
      invoiceNo: invoiceMap[item.SalesOrder] || ''
    }));
  };

  // Main export process - called when button is clicked
  handleExport = async () => {
    // Update multiple state properties at once
    this.setState({
      loading: true,
      status: null,
      logs: [],
      progress: 'Starting...'
    });

    try {
      // Step 1: Get sales orders
      this.setState({ 
        progress: 'Fetching sales orders...',
        currentStep: 1,
        totalSteps: 5
      });
      const salesOrders = await this.getSalesOrdersRequest();

      if (salesOrders.length === 0) {
        throw new Error('No sales orders found');
      }

      // Step 2: Get details for each order
      this.setState({ 
        progress: `Processing ${salesOrders.length} orders...`,
        currentStep: 2
      });
      const allItems = [];

      for (let i = 0; i < salesOrders.length; i++) {
        const orderNo = salesOrders[i];
        this.addLog(`Processing order ${i + 1}/${salesOrders.length}: ${orderNo}`);
        this.setState({ 
          progress: `Processing order ${i + 1} of ${salesOrders.length}...` 
        });
        
        const items = await this.getSalesOrderItemsRequest(orderNo);

        allItems.push(...items);
      }
      // Step 3: Get invoices
      this.setState({ progress: 'Fetching invoice data...' });this.setState({ 
        progress: 'Fetching invoice data...',
        currentStep: 3
      });
      const invoiceMap = await this.getInvoicedSalesOrdersRequest();
      // Step 4: Add invoice numbers
      this.setState({ 
        progress: 'Matching invoices...',
        currentStep: 4
      });
      const finalData = this.addInvoiceNumbers(allItems, invoiceMap);
      // Step 5: Export to CSV
      this.setState({ 
        progress: 'Generating file...',
        currentStep: 5
      });

      // Update state to show success
      this.setState({
        status: 'success',
        progress: `Successfully exported ${finalData.length} records!`,
        currentStep: 5,
        data: finalData
      });

    } catch (error) {
      const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message;
      
      // Update state to show error
      this.setState({
        status: 'error',
        progress: 'Export failed',
        errorMessage: errorMsg
      });
      
    } finally {
      // Always executed - stop loading spinner
      this.setState({ loading: false });
    }
  };

  // Render method - returns JSX
  render() {
    // Destructure state for easier access
    const { data, loading, progress, status, currentStep, totalSteps, errorMessage } = this.state;
    const progressPercentage = totalSteps > 0 ? (currentStep / totalSteps) * 100 : 0;

    return (
            <div id="GeneralPages" className="page">
              {/* Main menu */}
              <Menu Refresh={this.state.Refresh} Father={this} />
              <LoadingWindow ref={this.ModalLoading} />
              <div className='text-center my-4'>
                  <h2 className='display-4 fw-bold inventory-title'>Current Shipped Items Report</h2>
                  <p className='lead text-muted inventory-subtitle'>To start please click on the button.</p>
              </div>
              <div className='col-sm-12 text-center d-flex align-items-center'>
                <div className='col-sm-12 InputTextBolder'>
                    <button
                      onClick={this.handleExport}
                      disabled={loading}
                      style={{
                        ...styles.button,
                        ...(loading ? styles.buttonDisabled : styles.buttonActive)
                      }}
                    >
                      {loading ? (
                        <span>
                          <span style={styles.spinner} role='img' aria-label='loading-icon'>⏳</span> Processing...
                        </span>
                      ) : (
                        <span role='img' aria-label='export-icon'>📥 Export to CSV</span>
                      )}
                    </button>
                </div>
              </div>
              <div className='col-12'>
                {/* Progress Bar and Status */}
                {loading && (
                  <div style={styles.progressContainer}>
                    <div style={styles.progressText}>
                      {progress}
                    </div>
                    <div style={styles.progressBarBg}>
                      <div 
                        style={{
                          ...styles.progressBarFill,
                          width: `${progressPercentage}%`
                        }}
                      />
                    </div>
                    <div style={styles.progressSteps}>
                      Step {currentStep} of {totalSteps}
                    </div>
                  </div>
                )}

                {/* Success Message */}
                {status === 'success' && !loading && (
                  <div style={styles.successBox}>
                    <span style={styles.icon}>✓</span>
                    <div>
                      <div style={styles.successTitle}>Export Completed!</div>
                      <div style={styles.successText}>{progress}</div>
                    </div>
                  </div>
                )}

                {/* Error Message */}
                {status === 'error' && !loading && (
                  <div style={styles.errorBox}>
                    <span style={styles.icon}>✕</span>
                    <div>
                      <div style={styles.errorTitle}>Export Failed</div>
                      <div style={styles.errorText}>{errorMessage}</div>
                    </div>
                  </div>
                )}
              </div>

              <div hidden={data.length === 0} className='col-sm-12 mb-3'>
                <ExcelDocument 
                  data={getDataSet(data, ['Sales Order', 'Item Code', 'Description', 'Qty Ordered', 'Qty Shipped', 'Invoice'], ['SalesOrder', 'itemCode', 'description', 'qty_ordered', 'qty_shipped', 'invoiceNo'])} 
                  sheetname={"Shipped Items"} />
              </div>
              <div hidden={data.length === 0} className='col-sm-12'>
                <table className='table align-middle table-hover'>
                  <thead className='table-dark'>
                      <tr className='text-center'>
                          <td>Sales Order No</td>
                          <td>Item Code</td>
                          <td>Description</td>
                          <td>Quantity Ordered</td>
                          <td>Quantity Shipped</td>
                          <td>Invoice No</td>
                      </tr>
                  </thead>
                  <tbody>
                      {
                          data.length > 0 && (data.map((element, e) => (
                              <tr key={e} >
                                  <td className='text-center'>{element.SalesOrder}</td>
                                  <td className='text-center'>{element.itemCode}</td>
                                  <td className='text-center'>{element.description}</td>
                                  <td className='text-center'>{element.qty_ordered}</td>
                                  <td className='text-center'>{element.qty_shipped}</td>
                                  <td className='text-center'>{element.invoiceNo}</td>
                              </tr>
                          )))
                      }
                  </tbody>

                </table>
              </div>
            </div>
        )
    }
    
}
